/* eslint-disable sonarjs/no-duplicate-string */

import { defineMessages } from "react-intl";
import { useMessages } from "2g-hooks/intl";

const MESSAGES = defineMessages({
  filterLabelDateFrom: {
    id: "b2b.zadosti-historie-grid.filter.dateFrom.label",
    defaultMessage: "Date from"
  },
  filterLabelDateTo: {
    id: "b2b.zadosti-historie-grid.filter.dateTo.label",
    defaultMessage: "Date to"
  },
  filterLabelRequestStatus: {
    id: "b2b.zadosti-historie-grid.filter.requestStatus.label",
    defaultMessage: "Request status"
  },
  pageHeading: {
    id: "b2b.zadosti-historie-grid.label",
    defaultMessage: "Request history"
  },
  pageHeadingFilter: {
    id: "b2b.zadosti-historie-grid.action-filter",
    defaultMessage: "Filter"
  }
});

export default () => useMessages(MESSAGES);
